import { Component } from '@angular/core';
import { IonicPage, LoadingController, NavController, NavParams } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { UserProvider } from '../../providers/users/users';
import { UtilsProvider } from '../../providers/utils/utils';

@IonicPage()
@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
})
export class ProfilePage {
  user: any;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider,
    private utilsProvider: UtilsProvider,
    private userProvider: UserProvider,
    public loadingCtrl: LoadingController,
  ) {
    this.person = {name: undefined, company: undefined, birthdate: undefined, provider: null, role: null};
    this.dob = undefined;
  }

  ionViewDidLoad() {
    let id = this.navParams.get('uid');
    if(id === undefined) id = this.navParams.get('extras').uid;
    console.log('id',id);
    if(id === undefined) return
    this.presentLoading();
    this.userProvider.getUsers(false).subscribe(res => {
      if(res){
        let user = res.filter(user => user.uid ===  id);
        if(user.length){
          this.user = user[0];
          this.person.name = this.user.firstName + " " + this.user.lastName;
        }
      }
    })
    this.authProvider.getUser(id).subscribe(res => {
      this.loader.dismiss();
      if(res){
        this.user = res;
        this.person.name = this.user.firstName + " " + this.user.lastName;
      }
    })
  }

  public person: {name: string, company: string, provider: string, role: string, birthdate?: number};
  dob: any;
  age: any;
  showProfile: boolean;
  loader: any;

  reset(){
    this.person = {name: null, company: null, birthdate: null, provider: null, role: null};
    this.dob = null;
    this.showProfile = false;
  }

  save(){
    this.userProvider.updateUser(this.user).subscribe(res => {
      this.user = res;
    })
  }

  getRating() {
    if (!this.user) return null;
    let sum = 0;
    let result = 0;
    const arr = this.user.ranking;
    if (arr && arr.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        if (!isNaN(arr[i] && arr[i].score)) sum += arr[i].score;
      }
      result = sum / arr.length;
    } else {
      result = 0;
    }

    return result ? "Rating: " + result + "/5" : 'No Rating';
  }

  addImageInput(event){
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.utilsProvider.resizeImg(file).then(file => {
          reader.readAsDataURL(file);
          reader.onload = () => {
            const imgs = [{ data: reader.result.toString().split(',')[1] }]
            this.utilsProvider.uploadImages(imgs, 0, null, 0).subscribe(
              response => {
                console.log('uploaded: ', response.data.src);
                this.user.image = response.data.src
              },
              error => {
                console.log('error',error);
              },
            );
          };
        }).catch(e => {
          console.log("Upload Error",e)
      })
    }
  }

  presentLoading(content: string = '') {
    this.loader = this.loadingCtrl.create({
      content
    });
    this.loader.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts